// extracted by mini-css-extract-plugin
module.exports = {"aside_width":"230px"};